import React from 'react'
import { Valueimg } from '../imgs/imgs';
import Repeated from './Repeated';
import { Element } from 'react-scroll';

const Value = () => {
  return (
    <Element name="values">
    <Repeated imgName={Valueimg} flexType='flex-col-reverse md:flex-row' bg='bg-white' title='Our value' description="At Allo Moniteur, we are committed to providing high-quality, accessible, and safe driving education. Our core values include safety, excellence, and innovation. We firmly believe that everyone deserves to learn to drive in a secure and supportive environment. By connecting students with experienced and certified instructors, we aim to reduce road accidents and promote a culture of responsible driving."/>
    </Element>
  )
}

export default Value


